import { z } from 'zod';

import { optionalString, requiredString } from '@/shared/utils/validation';

export const createResourceGroupInputSchema = z.object({
  name: requiredString(),
  parentGroupId: optionalString().transform((value) => value || null),
});
